import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import styled, { withTheme } from "styled-components";

const StyledDropdown = styled(DropdownButton)`
  .dropdown-toggle {
    border-radius: 0.4rem;
    border: 2px solid transparent;
    font-weight: 600;
    padding: 0.25rem 0.7rem;
    font-size: 0.875rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    &::after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f078";
      border: 0px;
      margin-left: 30px;
    }
  }

  &.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0px 3px 6px #0000001a;
  }

  .dropdown-menu {
    box-shadow: 0px 3px 6px #0000004d;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;

    .dropdown-item {
      color: black;
      font-weight: 600;
      font-size: 16px;
      padding: 5px 15px;
    }
  }
`;

const ButtonDropdown = (props) => {
  const { title, options, size } = props;

  return (
    <StyledDropdown data-testid="btn-dropdown" size={size} title={title}>
      {options.map((item) => {
        if (item.isVisible) {
          return (
            <Dropdown.Item key={`key_${item.id ?? item}`}>
              <div onClick={item.onClick}>{item.text}</div>
            </Dropdown.Item>
          );
        }

        return null;
      })}
    </StyledDropdown>
  );
};

export default withTheme(ButtonDropdown);
